import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import SummaryWidgetCard from './SummaryWidgetCard';
import useFetchInventorySummary from '../../hooks/useFetchInventorySummary';
import { SUMMARY_WIDGET_CONFIGS } from '../../utils/inventorySummaryWidgets';

const WidgetsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  marginBottom: 24,
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'nowrap',
    overflowX: 'auto',
    paddingBottom: 8,
  },
}));

const InventorySummary = () => {
  const { fetchInventorySummary } = useFetchInventorySummary();

  useEffect(() => {
    fetchInventorySummary();
  }, []);

  return (
    <WidgetsRow>
      {SUMMARY_WIDGET_CONFIGS.map((config) => (
        <SummaryWidgetCard key={config.key} config={config} />
      ))}
    </WidgetsRow>
  );
};

export default InventorySummary;
